package com.shadowings.gero.data.lessons.chapter16

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.presentation.component.MdCWord

// A Gardiner string, centered, shrunk as it gets longer so a whole phrase fits the slide.
internal fun mdcSlide(gardiner: String): @Composable () -> Unit = {
    val size = when (gardiner.split("-").size) {
        in 0..4 -> 56.dp
        in 5..6 -> 48.dp
        else -> 40.dp
    }
    Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
        MdCWord(word = gardiner, rtl = false, cart = false, size = size)
    }
}

// Two groups side by side with an arrow, e.g. sḏm.f → pr.f.
internal fun mdcArrowSlide(from: String, to: String): @Composable () -> Unit = {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(16.dp, Alignment.CenterHorizontally),
        verticalAlignment = Alignment.CenterVertically
    ) {
        MdCWord(word = from, rtl = false, cart = false, size = 44.dp)
        Text(text = "→", style = MaterialTheme.typography.headlineMedium)
        MdCWord(word = to, rtl = false, cart = false, size = 44.dp)
    }
}
